// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  LANDING_TIME: 'Landing Time at {pickupPoint}',
  DRIVER_ARRIVES: 'Driver arrives, free waiting time starts',
  WAITING_TIME_ENDS: 'Free waiting time ends, charges may apply',
}

export default createMessages<typeof MESSAGES>(
  'UI_KIT_PICKUP_TIMELINE',
  MESSAGES
)
